import { Component, OnInit } from '@angular/core';
import { TimeKeeperDashboardService } from '../time-keeper-dashboard.service';
import { AuthGuard } from 'src/app/account/auth/app.gaurd';
import { HomepageDashbaordService } from './homepage-dashbaord.service';


  
@Component({
    selector: 'app-homepage-dashboard',
    templateUrl: './homepage-dashboard.component.html',
    styleUrls: ['./homepage-dashboard.component.scss'],
    standalone: false
})
export class HomepageDashboardComponent implements OnInit {
  isWidgetsLoading: Boolean = false;

  // Chart configurations
  chartConfigs: any[] = [{
    chartType: "Advanced Pie Chart",
    chartId: 1,
    chartName: "Open Task Due Date Pie Chart",
    data: [],
    colorScheme: {
      domain: ['green', 'yellow', 'orange', 'red']
    },
    view: [900, 250],
    animations: true
  }];
  
  // Dialog control
  widgetDialog: Boolean = false;
  showLpcDashboard: Boolean = false;
  showTimekeeperDashboard: Boolean = true;
  errorMsg: string = '';
  
  // Filter visibility state for each chart
  showFilters: { [key: string]: boolean } = {
    'projectsByLpa': false,
    'tasksByLpa': false,
    'openClosedRevenues': false,
    'projectDuration': false,
    'capacityByPerson': false,
    'tasksByPracticeArea': false
  };

  // Chart visibility based on user's assigned charts
  chartVisibility: { [key: string]: boolean } = {
    'openTaskDueDate': false,
    'projectsByLpc': false,
    'tasksByLpc': false,
    'openClosedRevenues': false,
    'projectDuration': false,
    'capacityByPerson': false,
    'tasksByPracticeArea': false,
    'tasksDue': false,
    'approvedTimeByPracticeArea': false
  };

  // Mapping of chart names (from API) to chart keys (frontend)
  // This is environment-independent and works across all databases
  private chartNameMapping: { [key: string]: string } = {
    'Open Task Due Date': 'openTaskDueDate',
    'Projects by LPC': 'projectsByLpc',
    'Tasks by LPC': 'tasksByLpc',
    'Open and Closed Revenues by Task Category': 'openClosedRevenues',
    'Project Duration - Estimated vs Actual Hours': 'projectDuration',
    'Capacity by Person': 'capacityByPerson',
    'Tasks by Practice Area': 'tasksByPracticeArea',
    'Tasks Due': 'tasksDue',
    'Approved Time by Practice Area': 'approvedTimeByPracticeArea'
  };

  // Array of visible charts for dynamic rendering
  visibleCharts: any[] = [];

  // Chart metadata for rendering
  private chartMetadata: { [key: string]: any } = {
    'openTaskDueDate': {
      key: 'openTaskDueDate',
      title: 'Open Task Due Date',
      component: 'advanced-pie',
      filterKey: null,
      fullWidth: true
    },
    'projectsByLpc': {
      key: 'projectsByLpc',
      title: 'Incomplete Projects by LPC',
      component: 'projects-by-lpa',
      filterKey: 'projectsByLpa',
      fullWidth: false
    },
    'tasksByLpc': {
      key: 'tasksByLpc',
      title: 'Tasks by LPC',
      component: 'tasks-by-lpa',
      filterKey: 'tasksByLpa',
      fullWidth: false
    },
    'openClosedRevenues': {
      key: 'openClosedRevenues',
      title: 'Open and Closed Revenues by Task Category',
      component: 'open-and-closed-revenues',
      filterKey: 'openClosedRevenues',
      fullWidth: false
    },
    'projectDuration': {
      key: 'projectDuration',
      title: 'Project Duration - Estimated vs Actual Hours',
      component: 'project-duration',
      filterKey: 'projectDuration',
      fullWidth: false
    },
    'capacityByPerson': {
      key: 'capacityByPerson',
      title: 'Capacity by Person',
      component: 'capacity-by-person',
      filterKey: 'capacityByPerson',
      fullWidth: false
    },
    'tasksByPracticeArea': {
      key: 'tasksByPracticeArea',
      title: 'Tasks by Practice Area',
      component: 'tasks-by-practice-area',
      filterKey: 'tasksByPracticeArea',
      fullWidth: false
    },
    'tasksDue': {
      key: 'tasksDue',
      title: 'Tasks Due',
      component: 'tasks-due',
      filterKey: null,
      fullWidth: false
    },
    'approvedTimeByPracticeArea': {
      key: 'approvedTimeByPracticeArea',
      title: 'Approved Time by Practice Area',
      component: 'time-distribution',
      filterKey: null,
      fullWidth: false
    }
  };

  
  constructor( public auth: AuthGuard,private dashboardService: HomepageDashbaordService) {

  }

  ngOnInit(): void {
    const roles = this.auth.roles;
    this.showLpcDashboard = roles.includes('LPC') || roles.includes('ADMIN');
    this.showTimekeeperDashboard = roles.includes('TK') || roles.includes('ADMIN');
    
    // Defer loadCharts to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.loadCharts();
    }, 0);
  }

   loadCharts() {
    this.isWidgetsLoading = true;
    
    this.dashboardService.getUserChartsList().subscribe({
      next: res => {
        let chartList = res?.data || [];
  
        // Reset all chart visibility to false
        Object.keys(this.chartVisibility).forEach(key => {
          this.chartVisibility[key] = false;
        });

        // Clear visible charts array
        this.visibleCharts = [];

        // Set visibility to true for assigned charts and build visibleCharts array
        chartList.forEach((chart: any) => {
          // Use chart name instead of ID for environment-independent mapping
          const chartKey = this.chartNameMapping[chart.name];
          if (chartKey) {
            this.chartVisibility[chartKey] = true;
            
            // Add chart metadata to visibleCharts array
            const metadata = this.chartMetadata[chartKey];
            if (metadata) {
              this.visibleCharts.push(metadata);
            }
          }
          
          // Load data for Open Task Due Date chart (ID 1)
          if (chart.id === 1 || chart.name === 'Open Task Due Date') {
            this.dashboardService.getChartsDataByChartId(chart.id).subscribe({
              next: res => {
                if (res && res.data) {
                  try {
                    this.chartConfigs[0].data = JSON.parse(res.data);
                  } catch (parseError) {
                    console.error(`Error parsing chart data for chart "${chart.name}":`, parseError);
                  }
                }
              },
              error: err => {
                console.error('Error fetching Open Task Due Date chart data:', err);
              }
            });
          }
        });
        
        this.isWidgetsLoading = false;
      },
      error: err => {
        console.error('Error fetching user charts list:', err);
        this.isWidgetsLoading = false;
      }
    });
  }
  
  onSelect(data:any): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data:any): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data:any): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

  openWidgetModal():any{
    this.widgetDialog=true;
  }

  closeDialog() {
    this.widgetDialog = false;
    // Reload charts when dialog closes to reflect any changes
    this.loadCharts();
  }

  /**
   * Toggle filter visibility for a specific chart
   * @param chartId The ID of the chart to toggle filters for
   */
  toggleFilter(chartId: string): void {
    // Toggle the filter visibility for the specified chart
    this.showFilters[chartId] = !this.showFilters[chartId];
    
    // If we're showing this filter, hide all other filters to avoid clutter
    if (this.showFilters[chartId]) {
      Object.keys(this.showFilters).forEach(key => {
        if (key !== chartId) {
          this.showFilters[key] = false;
        }
      });
    }
  }
}
